const VARIANT = process.env.REACT_APP_VARIANT || 'smart-sheets';

const variants = {
	'smart-sheets': {
		name: 'Base Ops',
		nav: 'default',
		sections: ['time-tracking', 'planning', 'money', 'invoicing', 'daily', 'reports', 'frontend'],
		defaultRoute: '/',
		showLazlo: true,
	},
	parallax: {
		name: 'Parallax',
		nav: 'parallax',
		sections: ['money'],
		defaultRoute: '/money',
		showLazlo: false,
	},
};

export const appVariant = variants[VARIANT] || variants['smart-sheets'];
export const isSection = (id) => appVariant.sections.includes(id);
